module.exports = __webpack_public_path__ + "img/orquesta2.fb299af4.jpg";